<section class="min-h-screen bg-base-200 px-4 py-6 sm:px-6">
  <div
    class="mx-auto flex min-h-[calc(100vh-3rem)] max-w-xl items-center justify-center"
  >
    <div
      class="w-full rounded-[calc(var(--radius-box)*2)] border border-base-300 bg-base-100 p-6 shadow-xl sm:p-10"
    >
      <div class="mb-8 flex items-center gap-4">
        <div
          class="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary text-primary-content"
        >
          <span class="brand-logo-text text-lg font-bold">
            {{ appConfig.shortName }}
          </span>
        </div>
        <div>
          <p class="text-xs uppercase tracking-[0.24em] text-base-content/45">
            Admin Workspace
          </p>
          <h1 class="brand-logo-text text-xl font-bold">
            {{ appConfig.name }}
          </h1>
        </div>
      </div>

      @if (checkingSession) {
        <div class="flex min-h-48 items-center justify-center">
          <span class="loading loading-spinner loading-lg text-primary"></span>
        </div>
      } @else if (!validSession) {
        <div class="space-y-5 text-center">
          <div
            class="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-error/10 text-error"
          >
            <i class="fa-solid fa-link-slash text-2xl"></i>
          </div>
          <div class="space-y-2">
            <h2 class="text-2xl font-black text-base-content">
              Reset link unavailable
            </h2>
            <p class="text-sm leading-6 text-base-content/60">
              This link is invalid or expired, or the account cannot access the
              admin panel. Request a new link from the login page.
            </p>
          </div>
          <a class="btn btn-primary" routerLink="/login">
            Return to login
          </a>
        </div>
      } @else {
        <div class="space-y-6">
          <div class="space-y-2">
            <h2 class="text-3xl font-black text-base-content">
              Choose a new password
            </h2>
            <p class="text-sm leading-6 text-base-content/60">
              Use at least 6 characters. You will sign in again after the
              password is updated.
            </p>
          </div>

          <div class="grid gap-5">
            <label class="form-control w-full">
              <div class="label pb-2">
                <span class="label-text font-medium">New password</span>
              </div>
              <label class="input input-bordered flex items-center gap-3 pr-2">
                <i class="fa-solid fa-lock text-base-content/40"></i>
                <input
                  [type]="showPassword ? 'text' : 'password'"
                  class="grow"
                  placeholder="Enter a new password"
                  [(ngModel)]="password"
                  autocomplete="new-password"
                />
                <button
                  type="button"
                  class="btn btn-ghost btn-sm btn-square text-base-content/40 hover:text-base-content"
                  (click)="showPassword = !showPassword"
                  aria-label="Toggle password visibility"
                >
                  <i class="fa-regular" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                </button>
              </label>
            </label>

            <label class="form-control w-full">
              <div class="label pb-2">
                <span class="label-text font-medium">Confirm password</span>
              </div>
              <label class="input input-bordered flex items-center gap-3 pr-2">
                <i class="fa-solid fa-lock text-base-content/40"></i>
                <input
                  [type]="showConfirmPassword ? 'text' : 'password'"
                  class="grow"
                  placeholder="Enter the new password again"
                  [(ngModel)]="confirmPassword"
                  autocomplete="new-password"
                />
                <button
                  type="button"
                  class="btn btn-ghost btn-sm btn-square text-base-content/40 hover:text-base-content"
                  (click)="showConfirmPassword = !showConfirmPassword"
                  aria-label="Toggle confirm password visibility"
                >
                  <i class="fa-regular" [ngClass]="showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                </button>
              </label>
            </label>

            <button
              type="button"
              class="btn btn-primary btn-lg"
              (click)="updatePassword()"
              [disabled]="submitting"
            >
              @if (submitting) {
                <span class="loading loading-spinner loading-sm"></span>
              } @else {
                <i class="fa-solid fa-key"></i>
              }
              Update password
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</section>
